import cls from 'classnames';
import { useState, useEffect } from 'react';

import GenericCarousel from '../../core/GenericCarousel/GenericCarousel';
import theme from '../../../styles/theme';
import useLayoutChange from '../../../hooks/useLayoutChange';

import useStyles from './styles';
import { BulletSliderProps } from './types';
import SliderFrame from './SliderFrame';
import SliderHeader from './SliderHeader';

const BASE_PADDING = 40;
const MOBILE_PADDING = 16;

function BulletSlider({
  backgroundColor = 'blue',
  bulletColor = 'white',
  className,
  items,
}: BulletSliderProps) {
  const [padding, setPadding] = useState(BASE_PADDING);
  const classes = useStyles({ backgroundColor });
  const [width] = useLayoutChange();

  useEffect(() => {
    if (width <= theme.breakpoints.laptop) {
      setPadding(MOBILE_PADDING);
    }
  }, [width]);

  if (items.length === 1) {
    const { header, title, description } = items[0];

    return (
      <div className={cls(classes.root, classes.rootSingle, className)}>
        <SliderFrame
          header={<SliderHeader text={header} />}
          title={title}
          description={description}
        />
      </div>
    );
  }
  return (
    <GenericCarousel
      bulletColor={bulletColor}
      className={cls(classes.root, className)}
      padding={padding}
    >
      {items.map((item, i) => (
        <SliderFrame
          key={`bs-${i}`}
          header={<SliderHeader text={item.header} />}
          title={item.title}
          description={item.description}
        />
      ))}
    </GenericCarousel>
  );
}

export default BulletSlider;
